<template>
  <div class="app-header d-flex align-center justify-space-between" :class="{ 'app-header--mobile': isMobile }">
    <div class="app-header__logo">
      <inline-svg :src="require('@/assets/icons/IconAILogoWhite.svg')" />
    </div>
    <multi-menu />
  </div>
  <div class="plan-mobile" v-if="isMobile">
    <div class="plan" v-if="plan?.name === 'Пробный'">
      <div class="plan__text">{{ $t('subscriptions.to-plan-end') }}</div>
      <ai-countdown :time="time" @end="endHandler" />
    </div>
    <div class="plan" v-else-if="plan?.name === 'Безлимитный на 30 дней'">
      <div class="plan__text">{{ $t('common.left') }}</div>
      {{ daysLeft }}
      <div class="plan__text" v-if="!isMobile">{{ $t('common.from') }}</div>
      <template v-if="!isMobile">{{ daysQn }}</template>
      <span class="limits-data__text"> {{ $t('common.d') }}. </span>
      <span class="limits-data__divider"> / </span>
      <span class="limits-data__text"> {{ plan.name }} </span>
      <div class="plan__text" v-if="!isMobile">
        {{ $t('profile.plan-text') }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import moment from 'moment';

import { useAuthStore } from '@/store/auth';
import { useCommonStore } from '@/store/common';

import AiCountdown from '@/components/UI/AiCountdown/AiCountdown.vue';

import MultiMenu from '@/components/common/MultiMenu/MultiMenu.vue';

const { plan, isAvailable } = storeToRefs(useAuthStore());

const { isMobile } = storeToRefs(useCommonStore());

const time = computed(() => {
  const currentDate = moment();
  const userExpDate = moment.utc(plan.value?.expiresAt).local();
  return userExpDate.diff(currentDate);
});

const daysLeft = computed(() => {
  const currentDate = moment();
  const expiresAt = moment.utc(plan.value?.expiresAt, 'YYYY-MM-DD HH:mm:ss');

  const diffInDays = expiresAt.diff(currentDate, 'days');
  return diffInDays + 1;
});

const daysQn = computed(() => {
  const connectedAt = moment.utc(plan.value?.connectedAt, 'YYYY-MM-DD HH:mm:ss');
  const expiresAt = moment.utc(plan.value?.expiresAt, 'YYYY-MM-DD HH:mm:ss');
  const diffInDays = expiresAt.diff(connectedAt, 'days');
  return diffInDays;
});

const endHandler = (): void => {
  isAvailable.value = false;
};
</script>

<style scoped lang="scss" src="./AppHeader.scss" />
